export const formatLastFourDigits = (value: string) =>
  value.replace(/\D/g, '').slice(0, 4)
